module.exports = __webpack_public_path__ + "img/icon_youtube_g.de3547fc.svg";